export const ENABLE_VIDEO_GUIDE = false;
export const ENABLE_PENDO_LOCALLY = false;
export const ENABLE_PENDO_FEEDBACK = true;
export const ENABLE_AGENTIC_AI = true;
export const USE_MOCK_PERFORMANCE_DATA = false;
export const SHOW_PERFORMANCE_V2_TOGGLE =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
        window.location.hostname.includes('-dev') ||
        window.location.hostname.includes('-test') ||
        window.location.hostname.includes('.local'));
